import BgImage from '../../assets/repayment-channel/repayment-channel-bg.png'
import { Box, Typography, } from '@mui/material'
import SMRepaymentChannel from '../../containers/RepaymentChannel'
import SMHomeContactUs from '../../containers/Home/ContactUs'
import { useTranslation } from 'react-i18next'

export const RepaymentChannelScreen: React.FC = () => {

    const { t } = useTranslation()

    // ======================= VIEWS
    return (
        <>
          <Box sx={{ position: 'relative', 
                objectFit: 'cover',
                backgroundImage: `url(${BgImage})`,                
                backgroundSize: 'cover',    
                backgroundPosition: 'center',
                width: '100%',
                height: '457px',
          }}>

          <Box sx={{ position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.4)', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
              <Typography fontSize={50} fontWeight={600} color={'#FBBF23'} textAlign={'center'}>
                  {t('t298')}
              </Typography>

              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignContent: 'center', alignItems: 'center', paddingTop: '16px' }}>
                  <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                    {t('t299')}
                  </Typography>
                  <Box sx={{ width: '1px', height: '20px', backgroundColor: '#FFFFFF', marginLeft: '20px', marginRight: '20px' }}></Box>
                  <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                    {t('t300')}
                  </Typography>
                  <Box sx={{ width: '1px', height: '20px', backgroundColor: '#FFFFFF', marginLeft: '20px', marginRight: '20px' }}></Box>
                  <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                    {t('t301')}
                  </Typography>
              </Box>
            </Box>
          </Box>
          <SMRepaymentChannel />
          <SMHomeContactUs />
        </>
    )
}

// ======================= EXPORT
export default RepaymentChannelScreen
